// extracted by mini-css-extract-plugin
export default {"badge":"xxbzH","smallIos":"_2TJMw","smallAndroid":"_2ID0m","buttonSize":"UL6gu","downloadButton":"_3UTtm"};